// import {
//   Component,
//   OnInit,
//   Input,
//   EventEmitter,
//   Output,
//   HostListener,
//   OnChanges,
//   SimpleChanges,
//   ViewChildren,
//   ElementRef,
//   QueryList,
//   AfterViewInit,
//   ChangeDetectorRef,
//   forwardRef,
//   ViewChild,
// } from '@angular/core';
// import { NG_VALUE_ACCESSOR } from '@angular/forms';
// import { FilterByPipe } from '../../pipe/filter-by.pipe';

// @Component({
//   selector: 'app-select-dropdown',
//   templateUrl: './select-dropdown.component.html',
//   styleUrls: ['./select-dropdown.component.css'],
//   providers: [
//     {
//       provide: NG_VALUE_ACCESSOR,
//       useExisting: forwardRef(() => SelectDropdownComponent),
//       multi: true,
//     },
//   ]
// })
// export class SelectDropdownComponent implements OnInit, OnChanges, AfterViewInit {

//   /** value of the dropdown */
//   @Input() public _value: any;

//   /**
//    * Get the required inputs
//    */
//   @Input() public options: any = [];

//   /**
//    * configuration options
//    */
//   @Input() public config: any = {};

//   /**
//    * Whether multiple selection or single selection allowed
//    */
//   @Input() public multiple = false;

//   /**
//    * Value
//    */
//   @Input() public disabled: boolean = false;

//     /**
//    * variable for single select
//    */

//   @Input() public singleSelect: boolean = false;
//   @Output() selectedObject = new EventEmitter<any>();
//   /**
//    * change event when value changes to provide user to handle things in change event
//    */
//   @Output() public change: EventEmitter<any> = new EventEmitter();

//   /**
//    * The search text change event emitter emitted when user type in the search input
//    */
//   @Output() public searchChange: EventEmitter<any> = new EventEmitter();

//   /**
//    * Event emitted when dropdown is open.
//    */
//   @Output() public open: EventEmitter<any> = new EventEmitter();

//   /**
//    * Event emitted when dropdown is open.
//    */
//   @Output() public close: EventEmitter<any> = new EventEmitter();

//   /**
//    * Toogle the dropdown list
//    */
//   public toggleDropdown = false;

//   /**
//    * Available items for selection
//    */
//   public availableItems: any = [];

//   /**
//    * Selected Items
//    */
//   public selectedItems: any = [];

//   /**
//    * Selection text to be Displayed
//    */
//   public selectedDisplayText = 'Select';

//   public selectedImageURL = '';

//   /**
//    * Search text
//    */
//   public searchText: string | null = '';

//   /**
//    * variable to track if clicked inside or outside of component
//    */
//   public clickedInside = false;

//   /**
//    * variable to track keypress event inside and outsid of component
//    */
//   public insideKeyPress = false;

//   /**
//    * variable to track the focused item whenuser uses arrow keys to select item
//    */
//   public focusedItemIndex: any = null;

//   /**
//    * element to show not found text when not itmes match the search
//    */

//   public showNotFound = false;
//   /**
//    * Hold the reference to available items in the list to focus on the item when scrolling
//    */
//   @ViewChildren('availableOption')
//   public availableOptions?: QueryList<ElementRef>;
//   @ViewChild('searchInput') searchInput!: ElementRef;
//   valueChange: any;
//   isLoading: boolean = true;
//   get value() {
//     return this._value;
//   }
//   set value(val) {
//     this._value = val;
//     this.onChange(val);
//     this.onTouched();
//   }

//   constructor(
//     private cdref: ChangeDetectorRef,
//     public _elementRef: ElementRef
//   ) {
//     this.multiple = false;
//   }

//   public onChange: any = () => {
//     // empty
//   }
//   public onTouched: any = () => {
//     // empty
//   }

//   /**
//    * click listener for host inside this component i.e
//    * if many instances are there, this detects if clicked inside
//    * this instance
//    */
//   @HostListener('click')
//   public clickInsideComponent() {
//     this.clickedInside = true;
//   }

//   @HostListener('blur') public blur() {
//     this.toggleDropdown = false;
//   }

//   @HostListener('focus') public focus() {
//     /* istanbul ignore else */
//     if (!this.disabled) {
//       this.toggleSelectDropdown();
//     }
//   }
//   /**
//    * click handler on documnent to hide the open dropdown if clicked outside
//    */
//   @HostListener('document:click')
//   public clickOutsideComponent() {
//     /* istanbul ignore else */
//     if (!this.clickedInside) {
//       this.toggleDropdown = false;
//       this.resetArrowKeyActiveElement();
//       // clear searh on close
//       this.searchText = null;
//       this.close.emit();
//     }
//     this.clickedInside = false;
//   }

//   /**
//    * click handler on documnent to hide the open dropdown if clicked outside
//    */
//   @HostListener('document:keydown')
//   public KeyPressOutsideComponent() {
//     /* istanbul ignore else */
//     if (!this.insideKeyPress) {
//       this.toggleDropdown = false;
//       this.resetArrowKeyActiveElement();
//     }
//     this.insideKeyPress = false;
//   }
//   /**
//    * Event handler for key up and down event and enter press for selecting element
//    */
//   @HostListener('keydown', ['$event'])
//   public handleKeyboardEvent($event: KeyboardEvent | any) {
//     this.insideKeyPress = true;
//     /* istanbul ignore else */
//     if ($event.keyCode === 27 || this.disabled) {
//       this.toggleDropdown = false;
//       this.insideKeyPress = false;
//       return;
//     }
//     const avaOpts = this.availableOptions?.toArray() || [];
//     /* istanbul ignore else */
//     if ($event.keyCode !== 9 && avaOpts.length === 0 && !this.toggleDropdown) {
//       this.toggleDropdown = true;
//     }
//     // Arrow Down
//     /* istanbul ignore else */
//     if ($event.keyCode === 40 && avaOpts.length > 0) {
//       this.onArrowKeyDown();
//       /* istanbul ignore else */
//       if (this.focusedItemIndex >= avaOpts.length) {
//         this.focusedItemIndex = 0;
//       }
//       avaOpts[this.focusedItemIndex].nativeElement.focus();
//       $event.preventDefault();
//     }
//     // Arrow Up
//     /* istanbul ignore else */
//     if ($event.keyCode === 38 && avaOpts.length) {
//       this.onArrowKeyUp();
//       /* istanbul ignore else */
//       if (this.focusedItemIndex >= avaOpts.length) {
//         this.focusedItemIndex = avaOpts.length - 1;
//       }
//       avaOpts[this.focusedItemIndex].nativeElement.focus();
//       $event.preventDefault();
//     }
//     // Enter
//     /* istanbul ignore else */
//     if ($event.keyCode === 13 && this.focusedItemIndex !== null) {
//       const filteredItems = new FilterByPipe().transform(
//         this.availableItems,
//         (this.searchText as string),
//         this.config.searchOnKey
//       );
//       this.selectItem(
//         filteredItems[this.focusedItemIndex],
//         this.availableItems.indexOf(filteredItems[this.focusedItemIndex])
//       );
//       return false;
//     }
//     return true;
//   }

//   /**
//    * Component onInit
//    */
//   public ngOnInit() {
//     /* istanbul ignore else */
//     if (typeof this.options !== 'undefined' && Array.isArray(this.options)) {
//       this.options.sort(this.config.customComparator);
//       this.availableItems = [
//         ...this.options,
//       ];
//       this.initDropdownValuesAndOptions();
//     }
//   }

//   /**
//    * after view init to subscribe to available option changes
//    */
//   public ngAfterViewInit() {
//     this.availableOptions?.changes.subscribe(this.setNotFoundState.bind(this));
//     this.setNotFoundState();
//   }

//   public registerOnChange(fn: any) {
//     this.onChange = fn;
//   }

//   public registerOnTouched(fn: any) {
//     this.onTouched = fn;
//   }

//   public setDisabledState(isDisabled: boolean) {
//     this.disabled = isDisabled;
//   }

//   public writeValue(value: any, internal?: boolean) {
//     if (value) {
//       if (Array.isArray(value)) {
//         this.ifValueIsArray(value)
//       } else {
//         this.value = value;
//       }
//       /* istanbul ignore else */
//       if (this.selectedItems.length === 0) {
//         if (Array.isArray(value)) {
//           this.selectedItems = value;
//         } else {
//           this.selectedItems.push(value);
//         }
//         this.initDropdownValuesAndOptions();
//       }
//     } else this.ifValueNotExist(internal)
//     /* istanbul ignore else */
//     if (!internal) {
//       this.reset();
//     }
//   }

//   public ifValueIsArray(value: any) {
//     if (this.multiple) {
//       this.value = value;
//     } else if (value.length > 0) {
//       this.value = value[0];
//     }
//   }

//   public ifValueNotExist(internal: boolean | undefined) {
//     this.value = null;
//     /* istanbul ignore else */
//     if (!internal) {
//       this.reset();
//     }
//   }

//   public reset() {
//     this.selectedItems = [];
//     this.availableItems = [...this.options.sort(this.config.customComparator)];
//     this.initDropdownValuesAndOptions();
//   }
//   /**
//    * function sets whether to show items not found text or not
//    */
//   public setNotFoundState() {
//     if (this.availableOptions?.length === 0) { // && !this.selectedItems.length
//       this.showNotFound = true;
//     } else {
//       this.showNotFound = false;
//     }
//     this.cdref.detectChanges();
//   }
//   /**
//    * Component onchage i.e when any of the input properties change
//    */
//   public ngOnChanges(changes: SimpleChanges) {
//     this.selectedItems = [];
//     this.options = this.options || [];
//     /* istanbul ignore else */
//     if (changes['options']) {
//       this.availableItems = [
//         ...this.options.sort(this.config.customComparator),
//       ];
//     }
//     /* istanbul ignore else */
//     if (changes['value']) {
//       /* istanbul ignore else */
//       if (
//         JSON.stringify(changes['value'].currentValue) === JSON.stringify([]) ||
//         changes['value'].currentValue === '' ||
//         changes['value'].currentValue === null
//       ) {
//         this.availableItems = [
//           ...this.options.sort(this.config.customComparator),
//         ];
//       }
//     }
//     this.initDropdownValuesAndOptions();
//   }


//   /**
//    * Deselct a selected items
//    * @param item:  item to be deselected
//    * @param index:  index of the item
//    */
//   public deselectItem(item: any, index: number) {
//     if (!this.isClearable) return;
//     this.selectedItems.forEach((element: any, i: number) => {
//       /* istanbul ignore else */
//       if (item === element) {
//         this.selectedItems.splice(i, 1);
//       }
//     });
//     let sortedItems = [...this.availableItems];
//     /* istanbul ignore else */
//     if (!this.availableItems.includes(item)) {
//       this.availableItems.push(item);
//       sortedItems = this.availableItems.sort(this.config.customComparator);
//     }
//     this.selectedItems = [...this.selectedItems];
//     this.availableItems = [...sortedItems];
//     /* istanbul ignore else */
//     if (!Array.isArray(this.value)) {
//       this.value = null;
//     }
//     this.valueChanged();
//     this.resetArrowKeyActiveElement();
//   }

//   /**
//    * Select an item
//    * @param item:  item to be selected
//    * @param index:  index of the item
//    */
//   public selectItem(item: string, index?: number) {
//     /* istanbul ignore else */
//     if (!this.multiple) {
//       /* istanbul ignore else */
//       if (this.selectedItems.length > 0) {
//         this.availableItems.push(this.selectedItems[0]);
//       }
//       this.selectedItems = [];
//       this.toggleDropdown = false;
//     }

//     this.availableItems.forEach((element: any, i: number) => {
//       /* istanbul ignore else */
//       if (item === element) {
//         this.selectedItems.push(item);
//         this.availableItems.splice(i, 1);
//       }
//     });

//     /* istanbul ignore else */
//     if (this.config.clearOnSelection) {
//       this.searchText = null;
//     }
//     this.selectedObject.emit(item);
//     this.selectedItems = [...this.selectedItems];
//     this.availableItems = [...this.availableItems];
//     this.selectedItems.sort(this.config.customComparator);
//     this.availableItems.sort(this.config.customComparator);
//     this.valueChanged();
//     this.resetArrowKeyActiveElement();
//   }

//   /**
//    * When selected items changes trigger the chaange back to parent
//    */
//   public valueChanged() {
//     this.writeValue(this.selectedItems, true);
//     this.change.emit({ value: this.value });
//     this.setSelectedDisplayText();
//   }

//   /**
//    * Toggle the dropdownlist on/off
//    */
//   public toggleSelectDropdown() {
//     setTimeout(()=>{ 
//       document.getElementById('searchInput')?.focus();
//     },);
//     this.toggleDropdown = !this.toggleDropdown;
//     if (this.toggleDropdown) {
//       this.open.emit();
//     } else {
//       this.searchText = null;
//       this.close.emit();
//     }
//     this.resetArrowKeyActiveElement();
//   }

//   /**
//    * The change handler for search text
//    */
//   public searchTextChanged() {
//     this.searchChange.emit(this.searchText);
//   }

//   public changeSearchText($event: any) {
//     $event.stopPropagation();

//   }

//   @Input('label') displayKey: string = 'label';
//   @Input('isClearable') isClearable: boolean = true;
//   @Input('invalid') invalid: boolean = false;
//   @Input('placeholder') placeholder: string = 'Select';
//   @Input('searchPlaceholder') searchPlaceholder: string = 'Search...';
//   @Input('search') search: boolean = false;
//   @Input('isStatus') isStatus: boolean = false;
//   @Input('showImage') showImage: boolean = false;
//   @Input('imageURL') imageURL: string = '';
//   @Input('combineDisplay') combineDisplay: string = '';

//   /**
//    * initialize the config and other properties
//    */
//   private initDropdownValuesAndOptions() {
//     const config: any = {
//       displayKey: 'description',
//       height: 'auto',
//       search: false,
//       placeholder: 'Select',
//       searchPlaceholder: 'Search...',
//       limitTo: 0,
//       customComparator: undefined,
//       noResultsFound: 'No results found!',
//       moreText: 'more',
//       searchOnKey: null,
//       clearOnSelection: false,
//       inputDirection: 'ltr',
//     };
//     /* istanbul ignore else */
//     if (this.config === 'undefined' || Object.keys(this.config).length === 0) {
//       this.config = { ...config };
//     }
//     for (const key of Object.keys(config)) {
//       this.config[key] = this.config[key] ? this.config[key] : config[key];
//     }
//     this.config = { ...this.config };
//     // Adding placeholder in config as default param
//     this.selectedDisplayText = this.config['placeholder'];
//     this.selectedImageURL = '';
//     /* istanbul ignore else */
//     if (this.value !== '' && typeof this.value !== 'undefined') {
//       if (Array.isArray(this.value)) {
//         this.selectedItems = this.value;
//       } else if (this.value !== '' && this.value !== null) {
//         this.selectedItems[0] = this.value;
//       } else {
//         this.selectedItems = [];
//         this.value = null;
//       }

//       this.selectedItems.forEach((item: any) => {
//         const ind = this.availableItems.findIndex(
//           (aItem: any) => JSON.stringify(item) === JSON.stringify(aItem)
//         );
//         if (ind !== -1) {
//           this.availableItems.splice(ind, 1);
//         }
//       });
//     }
//     this.setSelectedDisplayText();
//   }

//   /**
//    * set the text to be displayed
//    */
//   private setSelectedDisplayText() {
//     let text: string = this.selectedItems[0];
//     /* istanbul ignore else */
//     if (typeof this.selectedItems[0] === 'object') {
//       text = this.config.displayFn
//         ? this.config.displayFn(this.selectedItems[0])
//         : this.selectedItems[0][this.displayKey];
//       this.selectedImageURL = this.selectedItems[0][this.imageURL];
//     }
//     if (this.multiple && this.selectedItems.length > 0) {
//       this.selectedDisplayText =
//         this.selectedItems.length === 1
//           ? text
//           : text +
//           ` + ${this.selectedItems.length - 1} ${this.config.moreText}`;
//     } else {
//       this.selectedDisplayText =
//         this.selectedItems.length === 0 ? this.placeholder : text;
//     }
//   }

//   /**
//    * Event handler for arrow key up event thats focuses on a item
//    */
//   private onArrowKeyUp() {
//     /* istanbul ignore else */
//     if (this.focusedItemIndex === 0) {
//       this.focusedItemIndex = this.availableItems.length - 1;
//       return;
//     }
//     /* istanbul ignore else */
//     if (this.onArrowKey()) {
//       this.focusedItemIndex--;
//     }
//   }

//   /**
//    * Event handler for arrow key down event thats focuses on a item
//    */
//   private onArrowKeyDown() {
//     /* istanbul ignore else */
//     if (this.focusedItemIndex === this.availableItems.length - 1) {
//       this.focusedItemIndex = 0;
//       return;
//     }
//     /* istanbul ignore else */
//     if (this.onArrowKey()) {
//       this.focusedItemIndex++;
//     }
//   }

//   private onArrowKey() {
//     /* istanbul ignore else */
//     if (this.focusedItemIndex === null) {
//       this.focusedItemIndex = 0;
//       return false;
//     }
//     return true;
//   }

//   /**
//    * will reset the element that is marked active using arrow keys
//    */
//   private resetArrowKeyActiveElement() {
//     this.focusedItemIndex = null;
//   }

//   timeOutLoading(): boolean {
//     setTimeout(() => {
//       this.isLoading = false;
//     }, 3000);
//     return true
//   }

// }

import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  HostListener,
  OnChanges,
  SimpleChanges,
  ViewChildren,
  ElementRef,
  QueryList,
  AfterViewInit,
  ChangeDetectorRef,
  forwardRef,
  ViewChild,
  Renderer2,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FilterByPipe } from '../../pipe/filter-by.pipe';


@Component({
  selector: 'app-select-dropdown',
  templateUrl: './select-dropdown.component.html',
  styleUrls: ['./select-dropdown.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectDropdownComponent),
      multi: true,
    },
  ]
})
export class SelectDropdownComponent implements OnInit, OnChanges, AfterViewInit {

  /** value of the dropdown */
  @Input() public _value: any;

  /**
   * Get the required inputs
   */
  @Input() public options: any = [];
  @Input() public hideList: any = [];
  /**
   * configuration options
   */
  @Input() public config: any = {};

  /**
   * Whether multiple selection or single selection allowed
   */
  @Input() public multiple = false;

  /**
   * Value
   */
  @Input() public disabled: boolean = false;

  /**
   * Value
   */
  @Input() public initialLoader: boolean = false;

  /**
 * variable for single select
 */

  @Input() public singleSelect: boolean = false;

  /**
 * variable for single select close icon
 */
  @Input() public singleSelectClose: boolean = false;


  /**
   * change event when value changes to provide user to handle things in change event
   */
  @Output() public change: EventEmitter<any> = new EventEmitter();

  /**
   * The search text change event emitter emitted when user type in the search input
   */
  @Output() public searchChange: EventEmitter<any> = new EventEmitter();

  /**
   * Event emitted when dropdown is open.
   */
  @Output() public open: EventEmitter<any> = new EventEmitter();

  /**
   * Event emitted when dropdown is open.
   */
  @Output() public close: EventEmitter<any> = new EventEmitter();

  /**
   * Toogle the dropdown list
   */
  public toggleDropdown = false;

  /**
   * Available items for selection
   */
  public availableItems: any = [];

  /**
   * Selected Items
   */
  public selectedItems: any = [];

  /**
   * Selection text to be Displayed
   */
  public selectedDisplayText = 'Select';

  public selectedImageURL = '';

  /**
   * Search text
   */
  public searchText: string | null = '';

  /**
   * variable to track if clicked inside or outside of component
   */
  public clickedInside = false;

  /**
   * variable to track keypress event inside and outsid of component
   */
  public insideKeyPress = false;

  /**
   * variable to track the focused item whenuser uses arrow keys to select item
   */
  public focusedItemIndex: any = null;

  /**
   * element to show not found text when not itmes match the search
   */

  public showNotFound = false;
  /**
   * Hold the reference to available items in the list to focus on the item when scrolling
   */
  @ViewChildren('availableOption')
  public availableOptions?: QueryList<ElementRef>;

  @ViewChild('dropDownContainer') dropDownContainer!: ElementRef<HTMLDivElement>;
  @ViewChild('dropDownListContainer') dropDownListContainer?: ElementRef<HTMLDivElement>;
  @ViewChild('dropDownButton') dropDownButton?: ElementRef<HTMLDivElement>
  @ViewChild('dropDownSpan') dropDownSpan?: ElementRef<HTMLDivElement>
  @ViewChild('textwidth') textwidth?: ElementRef<HTMLDivElement>
  @ViewChild('searchBox') searchBox!: ElementRef<HTMLInputElement>
  hideVisible = false;
  valueChange: any;
  isLoading: boolean = true;
  posibleWidthOfElements!: number;
  dropdownFixedWidthToReduce = (64 + 44 + 20);
  keyDownListner !: EventListener;
  clickListener !: EventListener;
  // 44px for padding and margin and 64px for '+ more string'
  itemLegth = 0;
  isOverflow: boolean = false;
  get value() {
    return this._value;
  }
  set value(val) {
    this._value = val;
    this.onChange(val);
    this.onTouched();
  }

  constructor(
    private cdref: ChangeDetectorRef,
    public _elementRef: ElementRef,
    private renderer: Renderer2,
  ) {
    this.multiple = false;
  }

  public onChange: any = () => {
    // empty
  }
  public onTouched: any = () => {
    // empty
  }

  /**
   * click listener for host inside this component i.e
   * if many instances are there, this detects if clicked inside
   * this instance
   */

  /**
   * Component onInit
   */
  public ngOnInit() {
    /* istanbul ignore else */
    if (typeof this.options !== 'undefined' && Array.isArray(this.options)) {
      this.options.sort(this.config.customComparator);
      this.availableItems = [
        ...this.options,
      ];
      this.initDropdownValuesAndOptions();
    }


  }

  /**
   * after view init to subscribe to available option changes
   */
  public ngAfterViewInit() {
    this.availableOptions?.changes.subscribe(this.setNotFoundState.bind(this));
    this.setNotFoundState();

    let offstWidth = this.dropDownButton?.nativeElement.offsetWidth;
    if (offstWidth) {
      // this.posibleWidthOfElements = (offstWidth - (offstWidth * 0.4));
      this.posibleWidthOfElements = (offstWidth - this.dropdownFixedWidthToReduce);
      // if (this.dropDownSpan?.nativeElement) {
      //   this.renderer.setStyle(this.dropDownSpan?.nativeElement, 'width', this.posibleWidthOfElements + 'px');
      // }
    }
  }


  setDropDownPosition() {
    this.hideVisible = true;
    setTimeout(() => {
      this.setActiveDropDownPosition(this.dropDownContainer, this.dropDownListContainer, 260);
      this.hideVisible = false;
    });

  }

  public registerOnChange(fn: any) {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  public writeValue(value: any, internal?: boolean) {
    if (value) {
      if (Array.isArray(value)) {
        this.ifValueIsArray(value)
      } else {
        this.value = value;
      }
      /* istanbul ignore else */
      if (this.selectedItems.length === 0) {
        if (Array.isArray(value)) {
          this.selectedItems = value;
        } else {
          this.selectedItems.push(value);
        }
        this.initDropdownValuesAndOptions();
      }
    } else this.ifValueNotExist(internal)
    /* istanbul ignore else */
    if (!internal) {
      this.reset();
    }
  }


  public ifValueIsArray(value: any) {
    if (this.multiple) {
      this.value = value;
    } else if (value.length > 0) {
      this.value = value[0];
    }
  }

  public ifValueNotExist(internal: boolean | undefined) {
    this.value = null;
    /* istanbul ignore else */
    if (!internal) {
      this.reset();
    }
  }

  public reset() {
    this.selectedItems = [];
    this.availableItems = [...this.options.sort(this.config.customComparator)];
    this.initDropdownValuesAndOptions();
  }

  public closeSelected() {
    this.selectedItems = [];
    this.availableItems = [...this.options.sort(this.config.customComparator)];
    this.value = ''
    this.initDropdownValuesAndOptions();
    this.toggleDropdown = true;
  }
 
  /**
   * function sets whether to show items not found text or not
   */
  public setNotFoundState() {
    if (this.availableOptions?.length === 0 && !this.selectedItems.length) {
      this.showNotFound = true;
    } else {
      this.showNotFound = false;
    }
    this.cdref.detectChanges();
  }
  /**
   * Component onchage i.e when any of the input properties change
   */
  public ngOnChanges(changes: SimpleChanges) {
    this.selectedItems = [];
    this.options = this.options || [];
    /* istanbul ignore else */
    if (changes['options']) {
      this.availableItems = [
        ...this.options.sort(this.config.customComparator),
      ];
    }
    /* istanbul ignore else */
    if (changes['value']) {
      /* istanbul ignore else */
      if (
        JSON.stringify(changes['value'].currentValue) === JSON.stringify([]) ||
        changes['value'].currentValue === '' ||
        changes['value'].currentValue === null
      ) {
        this.availableItems = [
          ...this.options.sort(this.config.customComparator),
        ];
      }
    }
    this.initDropdownValuesAndOptions();
  }


  /**
   * Deselct a selected items
   * @param item:  item to be deselected
   * @param index:  index of the item
   */
  public deselectItem(item: any, index: number) {
    if (!this.isClearable) return;
    this.selectedItems.forEach((element: any, i: number) => {
      /* istanbul ignore else */
      if (item === element) {
        this.selectedItems.splice(i, 1);
      }
    });
    let sortedItems = [...this.availableItems];
    /* istanbul ignore else */
    if (!this.availableItems.includes(item)) {
      this.availableItems.push(item);
      sortedItems = this.availableItems.sort(this.config.customComparator);
    }
    this.selectedItems = [...this.selectedItems];
    this.availableItems = [...sortedItems];
    /* istanbul ignore else */
    if (!Array.isArray(this.value)) {
      this.value = null;
    }
    this.valueChanged();
    this.resetArrowKeyActiveElement();
  }

  /**
   * Select an item
   * @param item:  item to be selected
   * @param index:  index of the item
   */
  public selectItem(item: string, index?: number) {
    /* istanbul ignore else */
    if (!this.multiple) {
      /* istanbul ignore else */
      if (this.selectedItems.length > 0) {
        this.availableItems.push(this.selectedItems[0]);
      }
      this.selectedItems = [];
      this.toggleDropdown = false;
    }

    this.availableItems.forEach((element: any, i: number) => {
      /* istanbul ignore else */
      if (item === element) {
        this.selectedItems.push(item);
        this.availableItems.splice(i, 1);
      }
    });

    /* istanbul ignore else */
    if (this.config.clearOnSelection) {
      this.searchText = null;
    }

    this.selectedItems = [...this.selectedItems];
    this.availableItems = [...this.availableItems];
    this.selectedItems.sort(this.config.customComparator);
    this.availableItems.sort(this.config.customComparator);
    this.valueChanged();
    this.resetArrowKeyActiveElement();
  }

  /**
   * When selected items changes trigger the chaange back to parent
   */
  public valueChanged() {
    this.writeValue(this.selectedItems, true);
    this.change.emit({ value: this.value });
    this.setSelectedDisplayText();
  }

  /**
   * Toggle the dropdownlist on/off
   */
  public toggleSelectDropdown() {
    this.toggleDropdown = !this.toggleDropdown;
    this.setDropDownPosition();
    this.resetArrowKeyActiveElement();
    this.toggleDropdown ? this.activateDropdown() : this.resetDropdownvariables();
    setTimeout(() => {
      this.searchBox?.nativeElement.focus();
    }, 200);
  }

  /**
   * The change handler for search text
   */
  public searchTextChanged() {
    this.searchChange.emit(this.searchText);
  }

  public changeSearchText($event: any) {
    $event.stopPropagation();

  }

  @Input('label') displayKey: string = 'label';
  @Input('isClearable') isClearable: boolean = true;
  @Input('invalid') invalid: boolean = false;
  @Input('placeholder') placeholder: string = 'Select';
  @Input('searchPlaceholder') searchPlaceholder: string = 'Search...';
  @Input('search') search: boolean = false;
  @Input('isStatus') isStatus: boolean = false;
  @Input('showImage') showImage: boolean = false;
  @Input('imageURL') imageURL: string = '';
  @Input('combineDisplay') combineDisplay: string = '';

  /**
   * initialize the config and other properties
   */
  private initDropdownValuesAndOptions() {
    const config: any = {
      displayKey: 'description',
      height: 'auto',
      search: false,
      placeholder: 'Select',
      searchPlaceholder: 'Search...',
      limitTo: 0,
      customComparator: undefined,
      noResultsFound: 'No results found!',
      moreText: 'more',
      searchOnKey: null,
      clearOnSelection: false,
      inputDirection: 'ltr',
    };
    /* istanbul ignore else */
    if (this.config === 'undefined' || Object.keys(this.config).length === 0) {
      this.config = { ...config };
    }
    for (const key of Object.keys(config)) {
      this.config[key] = this.config[key] ? this.config[key] : config[key];
    }
    this.config = { ...this.config };
    // Adding placeholder in config as default param
    this.selectedDisplayText = this.config['placeholder'];
    this.selectedImageURL = '';
    /* istanbul ignore else */
    if (this.value !== '' && typeof this.value !== 'undefined') {
      if (Array.isArray(this.value)) {
        this.selectedItems = this.value;
      } else if (this.value !== '' && this.value !== null) {
        this.selectedItems[0] = this.value;
      } else {
        this.selectedItems = [];
        this.value = null;
      }

      this.selectedItems.forEach((item: any) => {
        const ind = this.availableItems.findIndex(
          (aItem: any) => this.displayKey ? item[this.displayKey] === aItem[this.displayKey] : JSON.stringify(item) === JSON.stringify(aItem)
        );
        if (ind !== -1) {
          this.availableItems.splice(ind, 1);
        }
      });
    }
    this.setSelectedDisplayText();
  }

  displayselectedDisplayText(){
    this.setSelectedDisplayText();
    this.initDropdownValuesAndOptions();
    return this.selectedDisplayText;
  }

  /**
   * set the text to be displayed
   */
  private setSelectedDisplayText() {
    let text: string = this.selectedItems[0];
    /* istanbul ignore else */
    if (typeof this.selectedItems[0] === 'object') {
      text = this.config.displayFn
        ? this.config.displayFn(this.selectedItems[0])
        : this.selectedItems[0][this.displayKey];
      this.selectedImageURL = this.selectedItems[0][this.imageURL];
    }
    if (this.multiple && this.selectedItems.length > 0) {
      this.selectedDisplayText =
        this.selectedItems.length === 1
          ? text
          : this.moreThanOneSelectedItem(text);
    } else {
      this.selectedDisplayText =
        this.selectedItems.length === 0 ? this.placeholder : text;
    }
  }


  moreThanOneSelectedItem(text: any) {
    let count = 0;
    let selectedItemText = '';
    let itemText = '';
    for (const item of this.selectedItems) {
      if (!count) {
        count++;
        if (typeof this.selectedItems[0] === 'object') {
          selectedItemText = item[this.displayKey];
        }
        else {
          selectedItemText = item;
        }
      }
      else {
        if (typeof this.selectedItems[0] === 'object') {
          itemText = selectedItemText + ', ' + item[this.displayKey];
        }
        else {
          itemText = selectedItemText + ', ' + item;
        }
        let selectedTextWidth = this.getTextWidth(itemText);
        if (selectedTextWidth && this.posibleWidthOfElements) {
          if (selectedTextWidth <= this.posibleWidthOfElements) {
            count++;
            selectedItemText = itemText;
          }
          else {
            break;
          }
        }
      }
    }
    if (count === this.selectedItems.length) {
      return selectedItemText
    }
    return selectedItemText + ` + ${this.selectedItems.length - count} ${this.config.moreText}`;
  }

  // moreThanOneSelectedItem(text: any) {
  //   let count = 0;
  //   let selectedItemText = '';
  //   for (const item of this.selectedItems) {
  //     if (!count) {
  //       count++;
  //       selectedItemText = item;
  //     }
  //     else {
  //       let itemText = selectedItemText + ', ' + item;
  //       let selectedTextWidth = this.utilityService.getTextWidth(itemText);
  //       if (selectedTextWidth && this.posibleWidthOfElements) {
  //         if (selectedTextWidth <= this.posibleWidthOfElements) {
  //           count++;
  //           selectedItemText = itemText;
  //         }
  //       else {
  //         break;
  //       }
  //       }
  //     }
  //   }
  //   if (count === this.selectedItems.length) {
  //     return selectedItemText
  //   }
  //   return selectedItemText +  ` + ${this.selectedItems.length - count} ${this.config.moreText}`;
  // }

  // moreThanOneSelectedItem(text:any) {
  //   return text + ` + ${this.selectedItems.length - 1} ${this.config.moreText}`;
  // }


  /**
   * Event handler for arrow key up event thats focuses on a item
   */
  private onArrowKeyUp() {
    /* istanbul ignore else */
    if (this.focusedItemIndex === 0) {
      this.focusedItemIndex = this.availableItems.length - 1;
      return;
    }
    /* istanbul ignore else */
    if (this.onArrowKey()) {
      this.focusedItemIndex--;
    }
  }

  /**
   * Event handler for arrow key down event thats focuses on a item
   */
  private onArrowKeyDown() {
    /* istanbul ignore else */
    if (this.focusedItemIndex === this.availableItems.length - 1) {
      this.focusedItemIndex = 0;
      return;
    }
    /* istanbul ignore else */
    if (this.onArrowKey()) {
      this.focusedItemIndex++;
    }
  }

  private onArrowKey() {
    /* istanbul ignore else */
    if (this.focusedItemIndex === null) {
      this.focusedItemIndex = 0;
      return false;
    }
    return true;
  }

  /**
   * will reset the element that is marked active using arrow keys
   */
  private resetArrowKeyActiveElement() {
    this.focusedItemIndex = null;
  }

  timeOutLoading(): boolean {
    setTimeout(() => {
      this.isLoading = false;
    }, 1000);
    return true
  }

  isAvalible() {

    if (Array.isArray(this.availableItems)) {
      if (this.availableItems.every(item => typeof item === 'object' && !Array.isArray(item))) {
        const searchText = this.searchText ? this.searchText.toLowerCase() : '';
        const found = this.availableItems.some(item => Object.values(item).some(value => {
          if (typeof value === 'string') {
            return value.toLowerCase().includes(searchText);
          }
          return false;
        }));
        return found ? false : true;
      }
      else {

        const filterItems = new FilterByPipe().transform(this.availableItems, this.searchText);
        return filterItems.length ? false : true;
      }
    } else {
      return true;
    }

  }

  selectedItemsTitle() {
    if (this.selectedItems.length) {
      if (typeof this.selectedItems[0] === 'object') {
        let item = [];
        for (const iterator of this.selectedItems) {
          item.push(iterator[this.displayKey])
        }
        return item.join(', ');
      }
      else {
        return this.selectedItems.join(', ');
      }
    }
    else { return '' }
  }

  onComponentFocused(event: any) {
    // this.activateDropdown();
    event.key === 'Tab' ? this.resetDropdownvariables() : this.handleKeyEvent(event);
  }

  resetDropdownvariables() {
    this.dropDownContainer.nativeElement.removeEventListener('keydown', this.keyDownListner);
    document.removeEventListener('click', this.clickListener);
    this.toggleDropdown = false;
    this.resetArrowKeyActiveElement();
    this.removeAllEventListeners();
    // clear searh on close
    this.searchText = null;
    this.close.emit();
    this.clickedInside = false;

  }

  handleKeyEvent($event: KeyboardEvent | any) {
    // $event.stopPropagation();
    if(!this.toggleDropdown){
      this.clickOutsideDropDown();
    }
    this.insideKeyPress = true;
    /* istanbul ignore else */
    if ($event.keyCode === 27 || this.disabled) {
      this.toggleDropdown = false;
      this.resetDropdownvariables();
      this.insideKeyPress = false;
      return;
    }
    const avaOpts = this.availableOptions?.toArray() || [];
    /* istanbul ignore else */
    if ($event.keyCode !== 9 && avaOpts.length === 0 && !this.toggleDropdown) {
      this.toggleDropdown = true;
      setTimeout(() => {
        this.searchBox?.nativeElement.focus();
      }, 200);
    }
    // Arrow Down
    /* istanbul ignore else */
    if ($event.keyCode === 40 && avaOpts.length > 0) {
      this.onArrowKeyDown();
      /* istanbul ignore else */
      if (this.focusedItemIndex >= avaOpts.length) {
        this.focusedItemIndex = 0;
      }
      avaOpts[this.focusedItemIndex].nativeElement.focus();
      $event.preventDefault();
    }
    // Arrow Up
    /* istanbul ignore else */
    if ($event.keyCode === 38 && avaOpts.length) {
      this.onArrowKeyUp();
      /* istanbul ignore else */
      if (this.focusedItemIndex >= avaOpts.length) {
        this.focusedItemIndex = avaOpts.length - 1;
      }
      avaOpts[this.focusedItemIndex].nativeElement.focus();
      $event.preventDefault();
    }
    // Enter
    /* istanbul ignore else */
    if ($event.keyCode === 13 && this.focusedItemIndex !== null) {
      const filteredItems = new FilterByPipe().transform(
        this.availableItems,
        (this.searchText as string),
        this.config.searchOnKey
      );
      this.selectItem(
        filteredItems[this.focusedItemIndex],
        this.availableItems.indexOf(filteredItems[this.focusedItemIndex])
      );
    if (!this.multiple) {
      document.body.click()
      this.resetDropdownvariables();
    }
      return false;
    }
    return true;
  }

  clickOutsideDropDown() {
    this.clickListener = (event: Event) => {
      const targetElement = event.target as Node;
      const dropdownElement = this.dropDownContainer.nativeElement;
      if (!this.multiple) {
        if (targetElement && !dropdownElement.contains(targetElement) ) {
          // Check if the clicked element is a child of the specific element If it's not, do something here
          this.resetDropdownvariables();
        }
      }
      if(this.multiple){
        if (targetElement && !dropdownElement.contains(targetElement) && !this.clickedInside) {
          // Check if the clicked element is a child of the specific element If it's not, do something here
          this.resetDropdownvariables();
        }
        this.clickedInside = false;
      }
    }
    this.removeAllEventListeners();
    document.addEventListener('click', this.clickListener);
  }

  checkEventPathForClass(path: any, selector: any): boolean {
    return path.some((p: any) => p.classList && p.classList.contains(selector));
  }

  removeAllEventListeners() {
    const eventTypes = ['click', 'keydown'];
    eventTypes.forEach((eventType) => {
      const eventListenerList = document.querySelectorAll(`[${eventType}]`);
      eventListenerList.forEach((element:any) => {
        element.removeEventListener(eventType, element[eventType]);
      });
    });
  }

  activateDropdown() {
    this.open.emit();
    this.clickedInside = true;
    this.clickOutsideDropDown();
  }
  
  //for managing the postion of the dropdown
  getScrollParent(el: any, position: string): any {
    if (el === null || !(el instanceof Element)) {
      return null;
    }
    let overflow: string = '';
    if (position === 'x') {
      overflow = window.getComputedStyle(el).overflowX;
    }
    {
      overflow = window.getComputedStyle(el).overflowY;
    }
    let isScrollable = overflow !== 'visible';
    if (isScrollable) {
      return el;
    } else {
      return this.getScrollParent(el.parentNode, position);
    }
  }

  setActiveDropDownPosition(
    dropDownContainer?: ElementRef,
    dropDownListContainer?: ElementRef,
    minWidth: number = 260,
    setHeight = true
  ) {
    const dropDownXContainer = this.getScrollParent(
      dropDownContainer?.nativeElement.parentNode,
      'x'
    );
    // const dropDownYContainer = this.getScrollParent(this.dropDownContainer?.nativeElement.parentNode,'y');
    if (dropDownContainer && dropDownListContainer) {
      if (dropDownXContainer) {
        const scrollContanerDimensions: DOMRect =
          dropDownXContainer.getBoundingClientRect();
        const containerDimensions =
          dropDownContainer.nativeElement.getBoundingClientRect();
        const listDimensions =
          dropDownListContainer.nativeElement.getBoundingClientRect();
        const topDiff =
          containerDimensions.top -
          listDimensions.height -
          scrollContanerDimensions.top;
        const bottomDiff =
          scrollContanerDimensions.bottom -
          containerDimensions.bottom -
          listDimensions.height;
        const rightDiff =
          scrollContanerDimensions.right - minWidth - containerDimensions.right;
        if (rightDiff < 0) {
          dropDownListContainer.nativeElement.classList.add('show-right');
        } else {
          dropDownListContainer.nativeElement.classList.remove('show-right');
        }
        if (bottomDiff < 0 && topDiff > bottomDiff) {
          dropDownListContainer.nativeElement.classList.add('show-top');
          this.renderer.setStyle(dropDownListContainer.nativeElement, 'bottom', `${dropDownContainer.nativeElement.offsetHeight}px`);
          if (topDiff < 0 && setHeight) {
            dropDownListContainer.nativeElement.style['max-height'] =
              containerDimensions.top - scrollContanerDimensions.top + 'px';
          }
        } else {
          dropDownListContainer.nativeElement.classList.remove('show-top');
        }
      }
    }
  }



  scrollTo(el: Element) {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const input: any = el.querySelector('.form-control');
      if (input) {
        input?.focus();
      }
      const firstChild = el.firstChild;
      if (input === firstChild) {
        input?.focus();
      }
    }
  }

  getTextWidth(text: string): number {
    const canvas = document.createElement('canvas');
    const metrics = canvas?.getContext('2d')?.measureText(text);
    return metrics?.width ? metrics?.width : 0;
  }


}
